


export default function Error(){

    return(
        <h1>Page Not Found</h1>
    )
}